import type { RendererPort, Immutable } from '@dissidium/view-contract';
import type { WorldView } from '@dissidium/contracts';
export class NullRenderer implements RendererPort {
  #view: Immutable<WorldView> | null = null;
  mount(_surface: { target: unknown; width: number; height: number }): void {}
  resize(_width: number, _height: number): void {}
  project(view: Immutable<WorldView>): void { this.#view = view; }
  draw(): void {}
  pick(_x: number, _y: number): string | null { return null; }
  dispose(): void { this.#view = null; }
  get simulationHash(): string | null { return this.#view?.simulationHash ?? null; }
}
